import type { PaymentMethod } from "@nura/contracts";

type PreparedPaymentAttempt = Readonly<{
  cacheKey: string;
  idempotencyKey: string;
}>;

export function createPaymentAttemptRegistry(
  generateKey: () => string = () => crypto.randomUUID(),
  maxPolls = 150,
) {
  const idempotencyKeys = new Map<string, string>();
  let active: { paymentId: string; cacheKey: string; polls: number } | undefined;

  return {
    prepare(packageCode: string, method: PaymentMethod): PreparedPaymentAttempt {
      const cacheKey = `${packageCode}:${method}`;
      const idempotencyKey = idempotencyKeys.get(cacheKey) ?? generateKey();
      idempotencyKeys.set(cacheKey, idempotencyKey);
      return { cacheKey, idempotencyKey };
    },
    activate(cacheKey: string, paymentId: string): void {
      active = { cacheKey, paymentId, polls: 0 };
    },
    activePaymentId(): string | undefined {
      return active?.paymentId;
    },
    nextPoll(paymentId: string): boolean {
      if (active?.paymentId !== paymentId || active.polls >= maxPolls) return false;
      active.polls += 1;
      return true;
    },
    pause(paymentId: string): void {
      if (active?.paymentId === paymentId) active = undefined;
    },
    release(paymentId: string): void {
      if (active?.paymentId !== paymentId) return;
      idempotencyKeys.delete(active.cacheKey);
      active = undefined;
    },
  };
}
